import React from "react";
import Productpage from "../../productpage2";

import SEO from "../../seo";

export default function ChiroChargePage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-04.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-01.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-02.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-03.png",
    ],
    productName: "Chiro Charge",
    // productLogo:
    //   "https://eclipsemattress.in/wp-content/uploads/2021/06/Eclipse_sub-brand_logo-02.png",
    descriptionTitle: "POCKET EURO TOP",
    descriptionText:
      "Eclipse Chiro Charge ET is especially designed for the hospitality industry to offer best rest and comfort to the clients. Created with high-tensile pocketed springs at core and Eurotop construction, it works on stress points by taking up the body posture. Individual pocketed springs provides ultimate lumbar support for vertebrae to avoid back aches and pain.",
    // availableSizes: "6″, 8″ & 10",
    category: { title: "Hospitality Series", link: "/hospitality/" },
    points: [
      "HD Eclipse Pure foam",
      "High tensile pocketed springs at core",
      "Euro Top Construction",
      "Excellent lumbar support",
      "Conforms to the highest US Bedding Standards",
      "Medium-Firm mattress",
    ],

    featuresText: [
      "HD Eclipse Soft Foam for quilting",
      "HD Eclipse Plush Foam",
      "Imported Turkish",
      // "PP Mesh for durability",
      "Stonger border wire construction with butterfly M-Springs as edge support on perimeter",
      "Pocketed Spring System",
      // "Good for people who have long sitting hours at work",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-06.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-07.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-08.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-09.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-10.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-11.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-13.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-14.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-15.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-16.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-12.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/chiro-charge/CHIRO-charge-05.png",
    // price: "₹34,399 - ₹1,01,799",
    relatedProducts: [
      {
        title: "Chiro Elite",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-elite.jpg",
        link: "/hospitality/chiro-elite/",
      },

      {
        title: "Chiro Charge PT",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-charge-pt.jpg",
        link: "/hospitality/chiro-charge-pt/",
      },
      // {
      //   title: "Chiro Charge",
      //   img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-charge.jpg",
      //   link: "/hospitality/chiro-charge/",
      // },
      {
        title: "Chiro Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-coil.jpg",
        link: "/hospitality/chiro-coil/",
      },
    ],

    color: "#EFE5D8",
  };

  return (
    <div>
      <SEO
        title="Chiro Charge ET |  Hospitality Series | Eclipse Mattress"
        description="Designed for the best hotel brands in the world with high tensile pocketed springs and Eurotop construction for premium comfort."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-chirocharge.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
